import styled from 'styled-components';

export const CardSelectorContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
`;

export const CardSelectorContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
`;

export const CardSelectorTitle = styled.h1`
    font-size: 32px;
    line-height: 40px;
    font-weight: 400;
    color: #0d0d0d;
    margin: 0;
    text-align: center;
`;

export const CardSelectorDescription = styled.p`
    font-size: 18px;
    line-height: 28px;
    font-weight: 200;
    color: #333;
    margin: 0;
    text-align: center;
`;

export const CardSelectorButtonsRow = styled.div`
    display: flex;
    gap: 16px;
    padding: 0 24px;
    margin: 0 auto;
    flex-wrap: wrap;
    justify-content: center;
`;

export const CardSelectorButtonContainer = styled.div`
    border-radius: 6px;
    border: 1px solid #7e7e7e;
    padding: 16px 6px;
    background-color: #fff;
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    &:hover {
        box-shadow: inset 0 0 0 2px #00697c;
    }

    &:hover > span {
        font-weight: 600;
    }
`;

export const CardSelectorButtonTitle = styled.span`
    font-size: 18px;
    line-height: 28px;
    font-weight: 200;
    text-align: center;
    color: #0d0d0d;
`;
